
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { IReporterCollection } from '@/types/reporter-types'
import { ElForm } from 'element-ui/types/form'
import { FileService } from '@/services/index'
import { IMG_HOST } from '@/config/env'
import * as qiniu from 'qiniu-js'

@Component
export default class extends Vue {
    @Prop({ type: Boolean, default: false }) private show: boolean = false
    @Prop({ type: Object, default: {} }) private data!: Object
    @Prop({ type: String, required: true }) private type!: string
    
    @Watch('show') // 需要整理
    onShowChange(val: boolean) {
        this.dialogShow = val
    }

    private dialogShow: boolean = false
    private previewDisplay: boolean = false
    private imgFile: any = ''
    private imgSrc: string = ''
    private imgValidate: boolean = true
    private loading: any
    private centerDialogVisible: boolean = true
    private collectionForm: IReporterCollection = { cover_img: '', memo: '', name: '', order: '' }
    private uploadStep: string = ''
    private formRules = {
        name: {
            required: true,
            message: '请输入正确名字，并不超过10个字符',
            max: 10
        },
        memo: {
            required: true,
            message: '请输入正确的简介，并不超过100个字符',
            max: 100
        },
        order: {
            trigger: 'change',
            validator: this.orderValidator
        }
    }

    @Emit('submit')
    private handleSubmit(item: IReporterCollection): IReporterCollection {
        return item
    }

    @Emit('close')
    private handleDialogCancel(): boolean {
        // 取消上传
        if (typeof (this as any).cancelUpload === 'function') {
            (this as any).cancelUpload()
        }
        const el = document.querySelector('.add-reporter-collection .el-dialog__body')
        ;(el as any).scrollTop = 0
        return false
    }

    private closeLoading() {
        this.loading && this.loading.close()
    }

    private async submitForm(formName: string) {
        const _this = this
        const config: any = {
            useCdnDomain: true,    // 启用 CDN 加速域名
            region: qiniu.region.z2 // 明确指定华南区域（bucket niumedia 在该区域）
        }
        
        // 默认配图地址
        const DEFAULT_COVER_IMG = 'https://images.media.beer/38992d511e154fd2a5a4770e9639f076.png'
        
        const file = this.imgFile
        const putExtra: any = {
            fname: '',   // string，文件原文件名
            params: {},  //object，用来放置自定义变量
            mimeType: ['image/png', 'image/jpeg', 'image/jpg'] || null   //用来限制上传文件类型，为 null 时表示不对文件类型限制；限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
        }
        
        // 测试模式：模拟上传失败
        const testMode = false // 设置为 true 启用测试模式
        const failUntilRetry = 5 // 在第几次重试后成功（从1开始）
        
        // 上传订阅对象，用于取消上传
        let uploadSubscription: any = null
        // 上传超时定时器
        let retryTimer: number | null = null
        
        // 取消上传
        const cancelUpload = () => {
            if (uploadSubscription) {
                uploadSubscription.unsubscribe()
                uploadSubscription = null
            }
            if (retryTimer) {
                clearTimeout(retryTimer)
                retryTimer = null
            }
            _this.uploadStep = ''
        }
        
        // 保存取消方法供外部调用
        _this.cancelUpload = cancelUpload
        
        // 上传图片方法（带重试机制）
        const maxRetries = 5
        const uploadWithRetry = async (retryCount: number = 0) => {
            try {
                // 获取上传凭证
                const result = await FileService.getToken()
                if (result.status !== 200) {
                    throw new Error('获取上传凭证失败')
                }
                
                const token = result.data.token
                const key = result.data.key
                
                return new Promise((resolve, reject) => {
                    _this.uploadStep = `正在上传图片...(第${retryCount + 1}次)`
                    
                    // 测试模式：模拟上传失败
                    if (testMode && retryCount < failUntilRetry - 1) {
                        _this.uploadStep = `测试模式：模拟上传失败...(第${retryCount + 1}次)`
                        retryTimer = window.setTimeout(() => {
                            retryTimer = null
                            // 模拟失败回调
                            uploadWithRetry(retryCount + 1).then(resolve).catch(reject)
                        }, 1000) // 测试模式下快速重试
                        return
                    }
                    
                    const observable = qiniu.upload(file, key, token, putExtra, config)
                    uploadSubscription = observable.subscribe({
                        error: function() {
                            uploadSubscription = null
                            if (retryCount < maxRetries) {
                                const delay = (retryCount + 1) * 5000 // n * 5秒
                                _this.uploadStep = `上传失败，${delay / 1000}秒后重试...(第${retryCount + 1}次)`
                                retryTimer = window.setTimeout(() => {
                                    retryTimer = null
                                    uploadWithRetry(retryCount + 1).then(resolve).catch(reject)
                                }, delay)
                            } else {
                                _this.uploadStep = ''
                                _this.$message.error('上传文件失败，请重新上传')
                                reject(new Error('上传失败，已达到最大重试次数'))
                            }
                        },
                        complete: function(result: any) {
                            uploadSubscription = null
                            const ext = file.name.split('.').pop() || 'png'
                            const keyWithExt = result.key.includes('.') ? result.key : `${result.key}.${ext}`
                            const url = IMG_HOST + keyWithExt
                            resolve(url)
                        }
                    })
                })
            } catch (error) {
                if (retryCount < maxRetries) {
                    const delay = (retryCount + 1) * 5000
                    _this.uploadStep = `获取凭证失败，${delay / 1000}秒后重试...(第${retryCount + 1}次)`
                    await new Promise(resolve => {
                        retryTimer = window.setTimeout(() => {
                            retryTimer = null
                            resolve(null)
                        }, delay)
                    })
                    return uploadWithRetry(retryCount + 1)
                } else {
                    _this.uploadStep = ''
                    _this.$message.error('上传文件失败，请重新上传')
                    throw error
                }
            }
        }
        
        ;(this.$refs[formName] as ElForm).validate(async (valid: boolean) => {
            if (valid) {
                // 如果没有上传图片且没有预览（新增且不上传），使用默认配图
                if (!file && !this.previewDisplay) {
                    this.collectionForm.cover_img = DEFAULT_COVER_IMG
                    this.dialogShow = false
                    return this.handleSubmit(this.collectionForm)
                }
                
                // 如果有图片需要上传
                if (file) {
                    try {
                        const url = await uploadWithRetry()
                        _this.uploadStep = '正在保存数据...'
                        setTimeout(() => {
                            _this.dialogShow = false
                            _this.collectionForm!.cover_img = url
                            _this.handleSubmit(_this.collectionForm!)
                            _this.uploadStep = ''
                        }, 300)
                    } catch (error) {
                        console.error('上传失败:', error)
                    }
                } else {
                    // 编辑模式下已有图片，直接保存
                    this.dialogShow = false
                    this.handleSubmit(this.collectionForm)
                }
            }
        })
    }

    private orderValidator(rule: any, value: any, callback: any) {
        const isNumber = typeof value === 'number'
        if (!isNumber && String(value).length > 0) {
            return callback('请输入正确的集合顺序')
        }
        if (value <= 0 && String(value).length > 0) {
            return callback('最小值为 1')
        }
        callback()
    }

    // 移除当前图片
    private onRemoveCurrentImage() {
        this.previewDisplay = false
        this.imgValidate = true
        // 清除当前选中的文件
        ;(document.getElementById('fileInput') as HTMLInputElement).value = ''
    }

    // 弹窗关闭后， 初始化操作
    private afterDialogClose(): void {
        this.previewDisplay = false
        this.dialogShow = false
        this.imgValidate = true
        this.imgSrc = ''
        this.collectionForm = { cover_img: '', memo: '', name: '' }
    }

    // 图片文件改变
    private onFileChange(event: any) {
        // @ts-ignore
        const _URL = window.URL || window.webkitURL
        let file = event.target.files[0]
        if (file.size / 1024 / 1024 > 2) {
            return this.$message.warning({
                showClose: true,
                message: '选择的配图不能大于2MB'
            })
        }
        if (file) {
            // 替换图片地址
            this.imgSrc = _URL.createObjectURL(file)
            if (!this.imgSrc) {
                this.$message({ type: 'error', showClose: true, message: '选择图片失败，请重试喔' })
            }
            this.previewDisplay = true
            this.imgFile = file
            this.imgValidate = true
        }
    }

    // 弹窗打开
    private handleDialogOpen(): void {
        if (this.type === 'edit') {
            if (this.collectionForm.cover_img !== (this.data as IReporterCollection).cover_img) {
                this.loading = this.$loading({
                    target: '.place-box'
                })
            }
            this.previewDisplay = true
            this.collectionForm = this.data as IReporterCollection
        }
        this.$refs['collectionForm'] && (this.$refs['collectionForm'] as ElForm).clearValidate()
    }
}
